module.exports = __webpack_public_path__ + "static/biotech-72250a9ecb13bdcac73a0eae44a28beb.jpg";